import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

import {AimoProduct} from '../../../../model/product.model';
import {DateUtils} from "../../../../shared/util/date-utils";
import {AimoProductService} from "../../../../service/product/aimo-product.service";

@Component({
    selector: 'aimo-last-purchased',
    templateUrl: './aimo-last-purchased.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AimoLastPurchasedComponent {
    @Input() product: AimoProduct;

    constructor(protected productService: AimoProductService,) {
    }

    getLastPurchasedTranslationKey(product: AimoProduct): string {
        return this.productService.getLastPurchasedTranslationKey(this.convertDate(product.lastPurchased));
    }

    convertDate(d: string): Date {
        return DateUtils.convertDate(d);
    }
}
